import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import VM from 'scratch-vm';
import {connect} from 'react-redux';

import ControlsComponent from '../components/controls/controls.jsx';

class Controls extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            isCameraOn: false
        };
        bindAll(this, [
            'handleCameraPreviewChanged',
            'handleCameraToggleClick',
            'handleGreenFlagClick',
            'handleStopAllClick'
        ]);
    }
    componentDidMount () {
        this.syncCameraStateFromRuntime();
        if (this.props.vm && this.props.vm.runtime) {
            this.props.vm.runtime.on('VISION_CAMERA_PREVIEW_CHANGED', this.handleCameraPreviewChanged);
        }
    }
    componentWillUnmount () {
        if (this.props.vm && this.props.vm.runtime) {
            this.props.vm.runtime.removeListener('VISION_CAMERA_PREVIEW_CHANGED', this.handleCameraPreviewChanged);
        }
    }
    syncCameraStateFromRuntime () {
        const runtimeVision = this.props.vm && this.props.vm.runtime && this.props.vm.runtime.visionClassifier;
        if (!runtimeVision || !runtimeVision.getState) return;

        const state = runtimeVision.getState();
        this.setState({
            isCameraOn: state.videoPreviewState !== 'off'
        });
    }
    handleCameraPreviewChanged (state) {
        this.setState({
            isCameraOn: state.videoPreviewState !== 'off'
        });
    }
    handleCameraToggleClick (e) {
        e.preventDefault();
        const runtimeVision = this.props.vm && this.props.vm.runtime && this.props.vm.runtime.visionClassifier;
        if (!runtimeVision || !runtimeVision.setCameraPreviewState) return;

        const runtimeState = runtimeVision.getState ? runtimeVision.getState() : null;
        const isCameraCurrentlyOn = runtimeState ? runtimeState.videoPreviewState !== 'off' : this.state.isCameraOn;
        const nextState = isCameraCurrentlyOn ? 'off' : 'on';
        runtimeVision.setCameraPreviewState(nextState);
        this.setState({
            isCameraOn: nextState === 'on'
        });
    }
    handleGreenFlagClick (e) {
        e.preventDefault();
        if (e.shiftKey) {
            this.props.vm.setTurboMode(!this.props.turbo);
        } else {
            if (!this.props.isStarted) {
                this.props.vm.start();
            }
            this.props.vm.greenFlag();
        }
    }
    handleStopAllClick (e) {
        e.preventDefault();
        this.props.vm.stopAll();
    }
    render () {
        const {
            vm, // eslint-disable-line no-unused-vars
            isStarted, // eslint-disable-line no-unused-vars
            projectRunning,
            turbo,
            ...props
        } = this.props;
        return (
            <ControlsComponent
                {...props}
                active={projectRunning}
                isCameraOn={this.state.isCameraOn}
                onCameraToggleClick={this.handleCameraToggleClick}
                turbo={turbo}
                onGreenFlagClick={this.handleGreenFlagClick}
                onStopAllClick={this.handleStopAllClick}
            />
        );
    }
}

Controls.propTypes = {
    isStarted: PropTypes.bool.isRequired,
    projectRunning: PropTypes.bool.isRequired,
    turbo: PropTypes.bool.isRequired,
    vm: PropTypes.instanceOf(VM)
};

const mapStateToProps = state => ({
    isStarted: state.scratchGui.vmStatus.running,
    projectRunning: state.scratchGui.vmStatus.running,
    turbo: state.scratchGui.vmStatus.turbo
});
// no-op function to prevent dispatch prop being passed to component
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Controls);
